var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/*
 * Copyright (c) 2019-present Sonatype, Inc.
 * This program and the accompanying materials are made available under
 * the terms of the Eclipse Public License 2.0 which accompanies this
 * distribution and is available at https://www.eclipse.org/legal/epl-2.0/.
 */
import React from 'react';
var defaultLogo = require('../../assets/img/logo_nexus_generic.svg');
import AbstractNxPageHeader from '../AbstractNxPageHeader/AbstractNxPageHeader';
import { propTypes } from './types';
import './NxNexusPageHeader.scss';
import { join, reject, isNil } from 'ramda';
function HeaderProductInfo(_a) {
    var name = _a.name, meta = _a.meta, version = _a.version;
    // note that combining these in JSX with a space in between would result in an extra space when one of the
    // fields isn't present, so we have to combine them more carefully like this
    var metaAndVersionString = join(' ', reject(isNil, [meta, version]));
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "nx-product__summary" },
            React.createElement("span", { className: "nx-product__brand" }, "nexus"),
            React.createElement("span", { className: "nx-product__name" }, name)),
        React.createElement("div", { className: "nx-product__details" },
            React.createElement("span", { className: "nx-product__byline" }, "from sonatype"),
            metaAndVersionString && React.createElement("span", { className: "nx-product__meta" }, metaAndVersionString))));
}
export default function NxNexusPageHeader(_a) {
    var productInfo = _a.productInfo, logoPath = _a.logoPath, otherProps = __rest(_a, ["productInfo", "logoPath"]);
    var logo = React.createElement("img", { src: logoPath || defaultLogo, className: "nx-product__logo-image", alt: "" }), productInfoContent = React.createElement(HeaderProductInfo, __assign({}, productInfo));
    return React.createElement(AbstractNxPageHeader, __assign({ className: "nx-page-header--nexus" }, otherProps, { logo: logo, productInfoContent: productInfoContent }));
}
NxNexusPageHeader.propTypes = propTypes;
//# sourceMappingURL=NxNexusPageHeader.js.map